var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonWorkMail32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-WorkMail_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-WorkMail_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Business-Applications",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.00021433,32.9998214 L7.00021433,7.70730488 L19.6469243,20.3535631 C19.7399443,20.4475799 19.8669715,20.4995892 20,20.4995892 C20.1330285,20.4995892 20.2600557,20.4475799 20.3540759,20.3535631 L32.9997857,7.70730488 L32.9997857,32.9998214 L7.00021433,32.9998214 Z M32.2926341,7.0001786 L20,19.2923736 L7.70736586,7.0001786 L32.2926341,7.0001786 Z M33.4998928,6 L6.50010717,6 C6.22404801,6 6,6.22404001 6,6.5000893 L6,33.4999107 C6,33.77596 6.22404801,34 6.50010717,34 L33.4998928,34 C33.7769522,34 34,33.77596 34,33.4999107 L34,6.5000893 C34,6.22404001 33.7769522,6 33.4998928,6 L33.4998928,6 Z",
    id: "Amazon-WorkMail_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonWorkMail32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-WorkMail_32.a00640892f60a0d2c4fc4e8c4e454f10.svg";
export { ForwardRef as ReactComponent };